import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default () => ({
	modal: "",
	init() {
		const alpine = this;
		const swiperContainer = alpine.$root.querySelector(".swiper");
		const swiper = new Swiper(swiperContainer, {
			modules: [Navigation, Pagination],
			slidesPerView: 1.4,
			spaceBetween: 20,
			loop: true,
			watchSlidesProgress: true,
			breakpoints: {
				1024: {
					slidesPerView: 2.4,
				},
			},
		});

		const hash = window.location.hash;
		if (hash) {
			const modalTrigger = this.$root.querySelector(`[href="${hash}"]`);
			if (modalTrigger) {
				this.$nextTick(() => {
					modalTrigger.click();
				});
			}
		}

		swiper.on("slideChange", (sw) => {
			console.log(sw.realIndex + 1, sw.slides.length);
			alpine.$refs.currentIndex.innerText = sw.realIndex + 1;
		});

		alpine.$root.querySelector(".next").addEventListener("click", (e) => {
			swiper.slideNext();
		});

		alpine.$root.querySelector(".prev").addEventListener("click", (e) => {
			swiper.slidePrev();
		});
	},
});
